import classNames from 'classnames'
import React from 'react'

import styles from './Message.css'

import SvgIcon from 'src/components/common/SvgIcon/SvgIcon'

export enum MessageType {
  INFO = 'info',
  WARNING = 'warning',
}

type Props = {
  className?: string
  children: React.ReactNode
  type?: MessageType
}

function Message({children, className, type = MessageType.INFO}: Props) {
  return (
    <div
      className={classNames(
        styles.container,
        {[styles.info]: type === MessageType.INFO},
        className,
      )}
    >
      <SvgIcon
        className={classNames({
          [styles.infoIcon]: type === MessageType.INFO,
          [styles.warningIcon]: type === MessageType.WARNING,
        })}
        icon={type === MessageType.INFO ? 'info' : 'warning'}
      />
      <div>{children}</div>
    </div>
  )
}

export default Message
